import { useCallback } from 'react';

import { api } from '@shared/api';
import { UserStore } from '@shared/store';

import { useQuery } from '@tanstack/react-query';

const useFetchLoanAgreements = (loanId: string) => {
  const { getUniqueIdentifier } = UserStore.useUserStore;
  const fetchLoanAgreements = useCallback(async () => {
    const response = await api.endpoints.getLoanAgreements({ params: { loanId } });
    return response.data;
  }, [loanId]);

  return useQuery({
    queryKey: ['loanAgreements', loanId, getUniqueIdentifier()],
    queryFn: fetchLoanAgreements,
    keepPreviousData: true,
    enabled: !!loanId,
  });
};

export { useFetchLoanAgreements };
